import React from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Card,
  CardContent,
} from '@mui/material';
import { WhatsApp, ContactSupport } from '@mui/icons-material';
import { styles } from './styles';

const Support: React.FC = () => {
  const whatsappNumber = '+5516997697037';
  const whatsappMessage =
    'Olá! Preciso de ajuda com minha assinatura do Clube da 42.';

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappUrl = `https://wa.me/${whatsappNumber.replace('+', '')}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <Container maxWidth="sm" sx={styles.container}>
      <Typography variant="h5" sx={styles.title} gutterBottom>
        Suporte
      </Typography>

      <Card sx={styles.supportCard}>
        <CardContent sx={styles.cardContent}>
          <Box sx={styles.iconContainer}>
            <ContactSupport sx={styles.supportIcon} />
          </Box>

          <Typography variant="h6" sx={styles.cardTitle} gutterBottom>
            Precisa de Ajuda?
          </Typography>

          <Typography variant="body1" sx={styles.description} gutterBottom>
            Nossa equipe de suporte está pronta para ajudar você com qualquer
            dúvida sobre sua assinatura, pedidos ou produtos.
          </Typography>

          <Typography variant="body2" sx={styles.subDescription} gutterBottom>
            Entre em contato conosco pelo WhatsApp e teremos prazer em ajudar!
          </Typography>

          <Button
            variant="contained"
            color="primary"
            startIcon={<WhatsApp />}
            onClick={handleWhatsAppClick}
            sx={styles.whatsappButton}
            size="large"
          >
            Falar no WhatsApp
          </Button>
        </CardContent>
      </Card>

      <Box sx={styles.infoSection}>
        <Typography variant="body2" sx={styles.infoText}>
          💡 <strong>Dica:</strong> Tenha em mãos seu número de pedido ou email
          cadastrado para um atendimento mais rápido.
        </Typography>
      </Box>
    </Container>
  );
};

export default Support;
